import mock from './mock'

import './jwt'
import './pages/faq'
import './apps/chat'
import './apps/todo'
import './apps/email'
import './apps/invoice'
import './apps/calendar'
import './apps/userList'
import './pages/profile'
import './apps/eCommerce'
import './pages/blog-data'
import './tables/datatables'
import './pages/pricing-data'
import './navbar/navbarSearch'
import './pages/knowledge-base'
import './apps/permissionsList'
import './cards/card-analytics'
import './cards/card-statistics'
import './pages/account-settings'
import './autoComplete/autoComplete'
import './apps/closure'
import './apps/meetings'
import './apps/uptakes'
import './apps/prospections'
import './apps/equipmentsLoan'
import './apps/equipments'
import './apps/access'
import './apps/comission'
import './apps/publication'
import './apps/attendance'
import './apps/loankey' 
import './apps/feepayments'
import './apps/office'
import './apps/kpisConfig'
import './apps/comissionMaster'
import './apps/unifiedInvoice'
import './apps/kpislist'
import './apps/kpisdetail'
import './apps/dashboardscoc'
import './apps/dashboardsglobal'

mock.onAny().passThrough()
